import React from 'react';
import PropTypes from 'prop-types';

import {
  Checkbox,
  Radio,
} from './styles';

import { TYPE_QUESTIONS } from '..';

const Options = (props) => {
  const {
    questionType = '',
    label,
    onChange,
    checked,
    key,
  } = props;

  if (questionType === TYPE_QUESTIONS.MULTIPLE_SELECT) {
    return <Checkbox label={label} onChange={onChange} checked={checked} key={key} />;
  }

  return <Radio label={label} onChange={onChange} checked={checked} key={key} />;
};

Options.propTypes = {
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  questionType: PropTypes.string.isRequired,
};

export default Options;
